// Section IDs used for navigation and anchoring
export const SECTIONS = [
  'hero-root',
  'services',
  'instinctive-labs',
  'network',
  'projects',
  'vision',
  'latest',
  'character-sheet',
  'contact'
];

// Service ID to display name mapping (used in contact form pre-fill)
export const SERVICE_NAMES = {
  'ai-agents': 'AI Agent Setup & Optimization',
  'bizdev': 'Business Development',
  'webdev': 'Website & Web App',
  'consulting': 'Web3 Project Consulting',
  'marketing': 'Marketing inquiries',
  'events': 'Partnership Opportunity'
};

/** Crypto Spaces Network partnership form — "Who referred you?" field entry id (from form HTML). */
const CRYPTO_SPACES_FORM_ID =
  '1FAIpQLSedb_dQpbthdkqZyanxY9e95qVQtOHSL7BItpzifhx0tFmxLw';
const CRYPTO_SPACES_REFERRAL_ENTRY_ID = '930523731';

export function getCryptoSpacesPartnershipUrl(referralName = 'Home') {
  const base = `https://docs.google.com/forms/d/e/${CRYPTO_SPACES_FORM_ID}/viewform`;
  const params = new URLSearchParams({
    usp: 'pp_url',
    [`entry.${CRYPTO_SPACES_REFERRAL_ENTRY_ID}`]: referralName
  });
  return `${base}?${params.toString()}`;
}

/** Hash link to contact section with optional pre-filled service + message. */
export function buildContactPrefillHash({ service, message }) {
  const params = new URLSearchParams();
  if (service) params.set('service', service);
  if (message) params.set('message', message);
  const q = params.toString();
  return q ? `#contact?${q}` : '#contact';
}

/**
 * Navigate to contact and force smooth scroll. This avoids browser anchor issues
 * with hashes like #contact?service=... (which are not valid DOM ids).
 */
export function navigateToContactPrefill({ service, message }) {
  const nextHash = buildContactPrefillHash({ service, message });
  if (window.location.hash !== nextHash) {
    window.location.hash = nextHash;
  } else {
    // Manually trigger hash listeners when hash string does not change.
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  }

  const contactEl = document.getElementById('contact');
  if (contactEl) {
    contactEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
